import React, { useEffect, useRef } from "react";
import { LANDING_HTML } from "./data/landingHtml";
import { LANDING_SCRIPT } from "./data/landingScript";
import { IMAGE_MAP, applyImageMap } from "./data/imageMap";
import { initPricing } from "./data/pricing";
import { INSIDE_HTML, initInside } from "./data/insideSection";

// El script arma las URLs como prefijo + id; se convierte a URLs completas antes de reemplazar.
function resolveScript(src: string): string {
  let s = src.split("var U='https://lh3.googleusercontent.com/d/';").join("var U='';");
  for (const [from] of IMAGE_MAP) {
    const id = from.replace("https://lh3.googleusercontent.com/d/", "");
    s = s.split("'+U+'" + id).join("'+'" + from);
  }
  // El bloque de precio viejo (interruptor Argentina / Otros países) lo reemplaza data/pricing.ts
  s = s.replace(/var P=\{ar:[\s\S]*?catch\(e\)\{\}/, "");
  return applyImageMap(s);
}
function resolveHtml(src: string): string {
  // Interruptor viejo -> selector de país con detección automática
  let html = src.replace(/<div class="tog"[\s\S]*?<\/div>/, '<div class="geo" id="geo"></div>');
  // Tomo 1: etiquetas combinadas para que las dos filas queden parejas
  html = html.split("<ul><li>Premios</li><li>Marcador</li><li>Casa preparada</li><li>Sesiones cortas</li></ul>").join("<ul><li>Casa preparada</li><li>Marcador</li><li>Premios</li><li>Sesiones cortas</li></ul>");
  // Lista de compra: los bonos dicen "Gratis" (en verde)
  html = html.split('<span class="g">Bono</span>').join('<span class="g free">Gratis</span>');
  // Nueva sección "Mira cómo se ve por dentro" (entre los tomos y los bonos)
  html = html.replace("<!-- BONOS -->", INSIDE_HTML + "<!-- BONOS -->");
  return applyImageMap(html);
}
export function App() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    root.innerHTML = resolveHtml(LANDING_HTML);
    document.title = "Perro Obediente en Casa | Entrenamiento con refuerzo positivo";
    let cleanup: unknown;
    let cleanupPricing: () => void = () => undefined;
    let cleanupInside: () => void = () => undefined;
    try {
      // eslint-disable-next-line no-new-func
      cleanup = new Function("return " + resolveScript(LANDING_SCRIPT))();
    } catch (e) {
      console.error(e);
    }
    try {
      cleanupPricing = initPricing(root);
    } catch (e) {
      console.error(e);
    }
    try {
      cleanupInside = initInside(root);
    } catch (e) {
      console.error(e);
    }
    return () => {
      if (typeof cleanup === "function") (cleanup as () => void)();
      cleanupPricing();
      cleanupInside();
      root.innerHTML = "";
    };
  }, []);
  return <div ref={ref} data-id="element-0" data-mp="3ljxw4kdcih82" />;
}